import React, {useState} from "react";
import {Header} from "../../components/Header";
import {SuperUserNavigationMenu} from "../../components/admin/SuperUserNavigationMenu";
import {Analytics} from "../../components/admin/Analytics";
import {ProfileClaimRequests} from "../../components/admin/ProfileClaimRequests";
import {Users} from "../../components/admin/Users";
import {Events} from "../../components/admin/Events";

export const Dashboard = () => {
	const [selectedMenuOption, setSelectedMenuOption] = useState("Analytics");

	const renderContent = () => {
		switch (selectedMenuOption) {
			case "Analytics":
				return (
					<Analytics
						selectedMenuOption={selectedMenuOption}
						setSelectedMenuOption={setSelectedMenuOption}
					/>
				)
			case "Profile Claims":
				return (
					<ProfileClaimRequests
						selectedMenuOption={selectedMenuOption}
						setSelectedMenuOption={setSelectedMenuOption}
					/>
				);
			case "Users":
				return (
					<Users
						selectedMenuOption={selectedMenuOption}
						setSelectedMenuOption={setSelectedMenuOption}
					/>
				)
			case "Events":
				return (
					<Events
						selectedMenuOption={selectedMenuOption}
						setSelectedMenuOption={setSelectedMenuOption}
					/>
				)
			default:
				return (
					<Analytics
						selectedMenuOption={selectedMenuOption}
						setSelectedMenuOption={setSelectedMenuOption}
					/>
				)
		}
	};

	return (
		<div
			className="bg-[#A20000] flex flex-col h-[100dvh] w-full
		        portrait:pt-[4rem] portrait:sm:pt-[5.5rem] portrait:jk:pt-[5rem]
		        landscape:pt-[3.5rem] landscape:jk:pt-[4.5rem]"
		>
			<Header/>

			<div
				className="flex flex-1 min-h-0 overflow-hidden
		            portrait:pb-[0.75rem] portrait:px-[0.75rem] portrait:gap-[0.75rem]
		            landscape:pb-[0.5rem] landscape:px-[0.5rem] landscape:gap-[0.5rem]"
			>
				<SuperUserNavigationMenu
					selectedMenuOption={selectedMenuOption}
					setSelectedMenuOption={setSelectedMenuOption}
				/>

				<div
					className="flex-1 min-h-0 overflow-hidden bg-white
                        shadow-xl shadow-black/25 rounded-xl"
				>
					{renderContent()}
				</div>
			</div>
		</div>
	);
}
